<template>
  <sp-col>
    <PaymentLineItemsRows />
    <DiscountRow />
    <sp-divider class="small-space"></sp-divider>
    <PaymentSummaryRow />
  </sp-col>
</template>

<script setup>
import PaymentLineItemsRows from "./PaymentLineItemsRows.ce.vue";
import PaymentSummaryRow from "./PaymentSummaryRow.ce.vue";
import DiscountRow from "./DiscountRow.ce.vue";
</script>

<style lang="scss" scoped>
sp-divider {
  &.small-space {
    margin: 1rem 0;
  }
}
</style>
